import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Project } from 'src/app/models/Project';
import { Customer } from 'src/app/models/Customer';
import { HomeElement } from 'src/app/models/HomepageElement';
import { WorkWithUs } from 'src/app/models/WorkWithUs';
import { Translate } from 'src/app/pipe/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  projects: Project[];
  customers: Customer[];
  home: HomeElement[];
  workWithUs: WorkWithUs[];
  section: string;
  constructor(private service: ApiService, private translate: Translate,
    private route: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    this.home = await this.service.getHomepageList();
    setTimeout(
      () => {
        this.route.paramMap.subscribe(params => {
          this.section = params.get('section');
          if (this.section)
            this.scroll(this.section);
        });
      }
      , 100
    );
  }
  getBrochureName() {
    let name = this.translate.transform("BROCHURE_NAME", 'pipeFilter') as string;
    return "../../../assets/download/" + name + ".pdf";
  }
  scroll(id: string) {
    // let el = document.getElementById(id);
    // el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // window.scrollBy(0,-200);


    const yOffset = -40;
    const element = document.getElementById(id);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
